import { element } from 'protractor';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mes-fruits',
  templateUrl: './mes-fruits.component.html',
  styleUrls: ['./mes-fruits.component.css']
})
export class MesFruitsComponent implements OnInit {


 lesFruits= [
  {
  nom : 'Pomme',

  couleur : 'verte'

  },
  {
    nom : 'Poire',

    couleur : 'jaune'

  },
  {
    nom : 'Peche',

    couleur : 'orange'

  },
  {
    nom : 'Banane',
    couleur : 'jaune'

  }
  ];
  uneMethode(){

 let unTableau = ['rouge', 'bleu'];

  unTableau.forEach((couleur)=>{

    console.log(couleur);

  })


  }


  constructor() { }

  ngOnInit(): void {
  }

}
